import React from 'react';
import PropTypes from 'prop-types';

import TabContentContainer from 'rebook/apps/base/components/TabContent/TabContentContainer';
import TabContentItem from 'rebook/apps/base/components/TabContent/TabContentItem';
import { USER_SETTINGS_PAGES } from 'rebook/apps/users/constants';

import styles from './style.scss';


class UserSettingsHeader extends React.Component {
  constructor(props) {
    super(props);
  }
  handleChangeUrl(tab) {
    const { url } = tab;
    this.props.history.push(url);
  }
  render() {
    const { history } = this.props;
    const defaultItem = USER_SETTINGS_PAGES.filter((item) => item.url === history.location.pathname)[0] || 0;

    return (
      <header className="sectionHeader">
        <div className={styles.blockWrapper}>
          <div className={'title-1'}>Настройки</div>
        </div>
        <TabContentContainer
          tabsListExtraClassName={styles.tabContainer}
          defaultItem={defaultItem.id}
          handleChange={(tab) => this.handleChangeUrl(tab)}>
          {USER_SETTINGS_PAGES.map((item, i) => (
            <TabContentItem
              extraClassName={styles.tabContentContainer}
              key={`${item.name}-${i}`}
              label={item.label}
              url={item.url}>
              {this.props.children}
            </TabContentItem>
          ))}
        </TabContentContainer>
      </header>
    );
  }
};

UserSettingsHeader.propTypes = {
  page: PropTypes.string.isRequired,
};

export default UserSettingsHeader;
